import { render } from "./CalculatorIncomeSection.vue?vue&type=template&id=09a55b0a&scoped=true&ts=true&lang=pug"
import script from "./CalculatorIncomeSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./CalculatorIncomeSection.vue?vue&type=script&lang=ts&setup=true"

import "./CalculatorIncomeSection.vue?vue&type=style&index=0&id=09a55b0a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a55b0a"]])

export default __exports__